import React from 'react';
import Header from '../Header';

import { useEffect, useState } from 'react'
import { connectState, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { Outlet, useSearchParams } from 'react-router-dom';
import Sidebar from '../NavBar/SideBar';
import { BottomBar } from '../NavBar/BottomBar';
import { useGrid } from '../../../utils/context/gridContext';
import * as S from './styles';
import SideBarOptions from '../../../utils/SideBarOptions';
import SimpleBarReact from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { RootStateBase } from '../../../store/baseStore';
import { useLocation } from 'react-router-dom'
import { IsStorybook, IsTest } from 'domain/utils/domainUtil';
import { PathName } from '../../../utils/routeUtil';
import { _UserData } from '../../../infra/storage/localStorage';
import { FrontOptions, FrontOptionsEnum } from 'domain/types/usuario/usuarioResponse';


const connector = connectState(
  (state: RootStateBase) => ({
    sideBarIgnore: state.UtilReducer.SideBarIgnore,
    headerIgnore: state.UtilReducer.HeaderIgnore,
  })
);

export interface RootProps extends PropsFromRedux<typeof connector> {
  toggleTheme?(): void;
  sideBarOptions?: Array<SideBarOptions>
  headerInfo?: React.ReactNode | JSX.Element
}

function Root (props: RootProps) {
  const { gridLeiaute } = useGrid();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [sideBarStatus, setSideBarStatus] = useState<boolean>(false)
  const [headerStatus, setHeaderStatus] = useState<boolean>(false)


  useEffect(() => {
    const options: FrontOptions = {};
    
    for (const key in FrontOptionsEnum) {
      const enumKey = key as keyof typeof FrontOptionsEnum;
      const param = searchParams.get(enumKey);

      if (param !== null) {
        (options as Record<string, boolean>)[enumKey] = param.toLowerCase() === 'true';
      }
    }
    
    if (Object.keys(options).length > 0) {
      _UserData.SetFrontOptions(options);
    }
  }, [searchParams])

  useEffect(() => {
    if(IsTest() ||  IsStorybook()){return}
    setSideBarStatus(((props.sideBarIgnore && (props.sideBarIgnore.includes("*") || props.sideBarIgnore.includes(PathName(location.pathname)))) ? false : true))
  }, [props.sideBarIgnore, location])


  useEffect(() => {
    if(IsTest() || IsStorybook()){return}
    setHeaderStatus((props.headerIgnore && (props.headerIgnore.includes("*") || props.headerIgnore.includes(PathName(location.pathname)))) ? false : true)
  }, [props.headerIgnore, location])

  return (
    <SimpleBarReact style={{ maxHeight: '100vh', width: '100%' }}>
      <S.Container $sidebar={(props.sideBarOptions != undefined && sideBarStatus)} position={gridLeiaute}>
        {headerStatus &&
          <S.ContainerHeader>
            <Header headerLeftInfo={props.headerInfo} toggleTheme={props.toggleTheme} />
          </S.ContainerHeader>
        }
        {props.sideBarOptions && sideBarStatus &&
          <S.ContainerSidebar>
            {gridLeiaute === 'bottom' && <BottomBar />}
            {gridLeiaute === 'left' && <Sidebar options={props.sideBarOptions} />}
          </S.ContainerSidebar>
        }
        <S.ContainerOutlet>
          <Outlet />
        </S.ContainerOutlet>
      </S.Container>
    </SimpleBarReact>
  );
}

export default connector(Root);
